import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getAppZones, getTemplateOptions } from './api';

export const path = '/app/indicator/list';

const PageAppTemplates: React.FC = (props) => {
  const AppTemplates = Loadable.Map({
    loader: {
      page: () => import('./page'),
      // остальные справочники (комнаты, типы помещений, типы замечаний) поля грузят сами через AsyncSearch
      zones: getAppZones,
      templateOptions: getTemplateOptions,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <AppTemplates {...props} />;
};

export default PageAppTemplates;
